import {
  getPaymentByRangeOfDates,
  getPaymentByDate
} from "@/collections/payments";

const state = { paymentHistory: [], paymentMethods: [] };

const mutations = {
  setPaymentHistory(state, val) {
    state.paymentHistory = val;
  },
  addPaymentMethod(state, data) {
    let found = state.paymentMethods.find(x => x.cardLast4 === data.cardLast4);
    if (!found) {
      state.paymentMethods.push(data);
    }
  },
  addPaymentId(state, data) {
    state.paymentId = data;
    window.localStorage.setItem("paymentId", state.paymentId);
  },
  addPaymentNumber(state, data) {
    state.paymentNumber = data;
    window.localStorage.setItem("paymentNumber", state.paymentNumber);
  }
};

const actions = {
  async paymentsHistoryByRangeOfDate({ commit }, rangeOfDates) {
    try {
      if (rangeOfDates.start.getTime() === rangeOfDates.end.getTime()) {
        let result = await getPaymentByDate(rangeOfDates.start);
        commit("setPaymentHistory", result);
      } else {
        let result = await getPaymentByRangeOfDates(
          rangeOfDates.start,
          rangeOfDates.end
        );
        commit("setPaymentHistory", result);
      }
    } catch (error) {
      this.setlogError(
        "get_payment_by_range_of_dates/payment_by_date",
        "Obtained error message in paymentsHistoryByRangeOfDate()",
        error.stack,
        this.$options.name
      );
    }
  }
};

const getters = {};

export default {
  state,
  mutations,
  actions,
  getters
};
